const getters = {
  previewTemplate: state => state.electronicLetter.previewTemplate,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js